// removed by extract-text-webpack-plugin
module.exports = {"test1":"test1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/ManagePendingRequest/test.scss
// module id = 5193
// module chunks = 1